import { api } from './api';
import { SiteModeData, ReadinessData, PillarDetailResponse, PageReadinessResponse, ModeTransitionEligibility } from '../types/mode.types';

/**
 * Get site mode classification
 */
export const getSiteMode = async (siteId: number): Promise<SiteModeData> => {
  const response = await api.get<SiteModeData>(`/earlystage/sites/${siteId}/mode`);
  return response.data;
};

/**
 * Get site readiness assessment
 */
export const getSiteReadiness = async (siteId: number): Promise<ReadinessData> => {
  const response = await api.get<ReadinessData>(`/earlystage/sites/${siteId}/readiness`);
  return response.data;
};

/**
 * Get detailed pillar assessment
 */
export const getPillarDetail = async (siteId: number, pillarId: string): Promise<PillarDetailResponse> => {
  const response = await api.get<PillarDetailResponse>(`/earlystage/sites/${siteId}/readiness/${pillarId}`);
  return response.data;
};

/**
 * Get page-level readiness assessments for all pages in a site
 */
export const getPageReadiness = async (
  siteId: number,
  page: number = 0,
  size: number = 50,
  sortBy: string = 'id',
  sortDir: string = 'ASC'
): Promise<PageReadinessResponse[]> => {
  const response = await api.get<PageReadinessResponse[]>(
    `/earlystage/sites/${siteId}/pages/readiness`,
    {
      params: { page, size, sortBy, sortDir }
    }
  );
  return response.data;
};

/**
 * Get readiness assessment for a single page
 */
export const getSinglePageReadiness = async (siteId: number, pageId: number): Promise<PageReadinessResponse> => {
  const response = await api.get<PageReadinessResponse>(`/earlystage/sites/${siteId}/pages/readiness/${pageId}`);
  return response.data;
};

/**
 * Check mode transition eligibility
 */
export const checkTransitionEligibility = async (siteId: number): Promise<ModeTransitionEligibility> => {
  const response = await api.get<ModeTransitionEligibility>(`/earlystage/sites/${siteId}/mode/transition-eligibility`);
  return response.data;
};

/**
 * Request manual transition to Performance mode
 */
export const requestModeTransition = async (siteId: number): Promise<ModeTransitionEligibility> => {
  const response = await api.post<ModeTransitionEligibility>(`/earlystage/sites/${siteId}/mode/request-transition`);
  return response.data;
};
